import React, {memo} from 'react'
import {KTSVG} from '../../../../../../_metronic/helpers'
import {formatDate} from '../../../../../utils/date'

type InvoiceCardProps = {
  invoice: any
  loadingDownload: boolean
  onUpdate: (invoice: any) => void
  onDownload: (event: React.MouseEvent, linkFile: string | null) => void
}

export const InvoiceCard = memo(function InvoiceCard({
  invoice,
  loadingDownload,
  onUpdate,
  onDownload,
}: InvoiceCardProps) {
  const statusClass =
    invoice.status === 'INFORMADO'
      ? 'success'
      : invoice.status === 'NÃO INFORMADO'
      ? 'danger'
      : 'secondary'

  return (
    <div
      className='bg-hover-primary'
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderRadius: '10px',
        padding: '0.5rem',
        cursor: 'pointer',
      }}
      onClick={() => onUpdate(invoice)}
    >
      <div style={{display: 'flex', alignItems: 'center'}}>
        <div className='symbol symbol-40px symbol-circle me-5'>
          <KTSVG
            path='/media/icons/duotune/ecommerce/ecm010.svg'
            className='svg-icon-muted svg-icon-2hx'
          />
        </div>
        <div>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fs-5'>{formatDate(invoice.mes)}</span>
          </h3>
        </div>
      </div>

      <div>
        <span className={`badge badge-light-${statusClass} fs-8 fw-semibold`}>
          {invoice.status || 'Não identificado'}
        </span>
      </div>

      <div>
        <button
          onClick={(event) => onDownload(event, invoice.link_file)}
          disabled={loadingDownload || !invoice.link_file}
          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
          style={{border: 'none', background: 'transparent'}}
        >
          <KTSVG path='/media/icons/duotune/files/fil017.svg' className='svg-icon-3' />
        </button>
      </div>
    </div>
  )
})
